export default __webpack_public_path__ + "static/media/formal-mini.d5f8be07.jpg";